export default {"src":"/_next/static/media/cplogo-icon-primary.ef142176.svg","height":78,"width":78,"blurWidth":0,"blurHeight":0};